// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React from 'react';

import {
  Banner,
  BannerBoldText,
  BannerFlexWrapper,
  BannerTextWrapper,
} from '../../Banner';

export const RestrictedRegistryWarningBanner = () => {
  return (
    <Tailwind>
      <Banner variant="warning" className="mt-16">
        <BannerFlexWrapper>
          <Icon name="info" style={{marginBottom: 'auto'}} />
          <BannerTextWrapper style={{display: 'inline-grid'}}>
            <BannerBoldText>
              Changing registry visibility to 'restricted'
            </BannerBoldText>
            Non members will not have access to this registry. You can
            add/manage users later from the registry settings section.
          </BannerTextWrapper>
        </BannerFlexWrapper>
      </Banner>
    </Tailwind>
  );
};
